module.exports = "https://99designs-start-assets.imgix.net/js/7869441fea2b0fa9e7c002a852d0e47d.png";